<template>
  <div class="download-menu" ref="menuRef">
    <button 
      class="download-button" 
      :class="{ 'is-open': open }" 
      :disabled="disabled"
      @click="open = !open">
      <i class="fa fa-download"></i>
      <span>Download Data</span>
      <i class="fa fa-chevron-down" :class="{ 'is-open': open }"></i>
    </button>

    <div class="download-dropdown" :class="{ 'is-open': open }">
      <button
        v-for="option in options"
        :key="option.value"
        class="download-option"
        @click="select(option)"
      >
        <i :class="option.icon"></i>
        <span>{{ option.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    default: () => [
      { value: 'csv', label: 'Download as CSV', icon: 'fa fa-file-csv' },
      { value: 'pdf', label: 'Download as PDF', icon: 'fa fa-file-pdf' },
      { value: 'png', label: 'Download as Image', icon: 'fa fa-image' },
    ],
  },
  // disable menu when data hasn't yet loaded
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select'])

const open = ref(false)
const menuRef = ref(null)

function select(option) {
  emit('select', option.value)
  open.value = false
}

function close() {
  open.value = false
}

function handleClickOutside(el) {
  if (menuRef.value && !menuRef.value.contains(el.target)) {
    close()
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onUnmounted(() => document.removeEventListener('click', handleClickOutside))
</script>

<style scoped>

.download-menu {
  position: relative;
  display: inline-block;
}
.download-dropdown {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
}
.download-dropdown.is-open {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}

.download-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.4rem 1rem;
  border: 1.5px solid #a9c2e8;
  border-radius: 6px;
  background: #eef4fc;
  color: #1a2b4a;
  font-size: 0.875rem !important;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  color: var(--color-text);
  width: fit-content;
}

.download-button:hover {
  background: #e2ecfb;
}


.download-button i.is-open {
  transform: rotate(180deg);
}

/* position: absolute keeps this from pushing surrounding
   dashboard content down/around when the menu opens */
.download-dropdown {
  width: fit-content;
  top: calc(100% + 6px);
  left: 0;
  z-index: 1000;
  min-width: 250px;
  height: fit-content;
  background: #eef4fc;
  border: 1px solid #d3e0f5;
  border-radius: 6px;
  box-shadow:
    0 4px 12px rgba(0,0,0,0.08),
    0 1px 3px rgba(0,0,0,0.12);
  overflow: visible;
}

.download-option {
  width: 100%;
  font-weight: 600;
  font-size: 0.75rem !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.25rem 1rem;
  border: none;
  background: transparent;
  color: #1a2b4a;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}

.download-option:hover {
  background: #e2ecfb;
}

.download-option:first-child {
  border-top: none;
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid #d3e0f5;
}
.download-option:last-child {
  border-bottom: none;
  border-top: 1px solid #d3e0f5;
  border-radius: 0 0 6px 6px;
}

</style>